import React from 'react';
import '../styles/PricingSection.css';

const PricingSection: React.FC = () => {
  const plans = [
    {
      name: "STARTER",
      subtitle: "Single Agent",
      description: "For SMEs wanting to test the waters",
      price: "€199",
      period: "month",
      features: [
        "Up to 5 RFQs / month",
        "Supplier search, RFQ requests, and quote comparison",
        "Basic savings dashboard",
        "Email support"
      ],
      buttonText: "Get Started",
      popular: false
    },
    {
      name: "PROFESSIONAL",
      subtitle: "Full AI Teammate",
      description: "For growing teams needing more",
      price: "€499",
      period: "month",
      features: [
        "Up to 25 RFQs / month",
        "Priority supplier outreach",
        "Supplier profiling including risk assessment & review assessment",
        "Custom supplier lists upload",
        "Advanced savings analytics",
        "Chat support + onboarding session"
      ],
      buttonText: "Get Started",
      popular: true
    },
    {
      name: "ENTERPRISE",
      subtitle: "AI RFQ Team",
      description: "For high-volume or complex procurement",
      price: "Custom",
      period: "pricing",
      features: [
        "Unlimited sourcing projects",
        "Multiple AI agents running in parallel",
        "API access & ERP integration",
        "Dedicated account manager",
        "Custom reporting & compliance checks"
      ],
      buttonText: "Contact Sales",
      popular: false
    }
  ];

  return (
    <section className="pricing-section">
      <div className="container">
        <h2 className="section-title">Start working with your new AI procurement teammate today.</h2>
        
        <div className="pricing-grid">
          {plans.map((plan, index) => (
            <div key={index} className={`pricing-card ${plan.popular ? 'popular' : ''}`}>
              {plan.popular && <div className="popular-badge">Most Popular</div>}
              
              <div className="card-header">
                <h3 className="plan-name">{plan.name}</h3>
                <p className="plan-subtitle">"{plan.subtitle}"</p>
                <p className="plan-description">{plan.description}</p>
              </div>
              
              <div className="card-pricing">
                <div className="price">
                  <span className="price-amount">{plan.price}</span>
                  <span className="price-period">/{plan.period}</span>
                </div>
              </div>
              
              <div className="card-features">
                <h4 className="features-title">Includes:</h4>
                <ul className="features-list">
                  {plan.features.map((feature, featureIndex) => (
                    <li key={featureIndex} className="feature-item">
                      <span className="checkmark">✓</span>
                      {feature}
                    </li>
                  ))}
                </ul>
              </div>
              
              <div className="card-action">
                <button className="cta-button">
                  {plan.buttonText}
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default PricingSection;
